import "./CartPage.css";
import { useEffect, useState } from "react";
import TopBar from "../../_common/topbar/TopBar";
import { Modal } from "@mui/material";
import {
  Loader,
  sample,
  note,
  view_headline,
  Bounding_box,
  room_img,
  hotel_pic,
  add_shopping_cart2,
  back_btn,
  production_quantity_limits2,
  close,
  traced,
  account_circle,
  phone_in_talk,
  mail,
  delete_img,
} from "../../../assets/images";
import { bookingimg } from "../../../assets/images";
import { withTranslation } from "react-i18next";
import useCartPage from "./useCartPage";
import ReactPaginate from "react-paginate";
import { commaValidation } from "../../../utility";
import { useRazorpay } from "../RazorPay/useRazorPay";

const CartPage = (props) => {
  const { t } = props;
  let { displayRazorpay } = useRazorpay();
  const {
    cartData,
    loader,
    // loading,
    editing,
    pageCount,
    current,
    calculatedRoomCharge,
    calculatedTaxgst,
    calculatedTotalAmt,
    user_name,
    user_email,
    user_phone,
    viewDetails,
    removeRooms,
    user_id,
    singleViewDetails,
    singleRoom,
    totalingRoomCharge,
    totalingGst,
    selectedAdults,
    selectedChilrenAbove8,
    extractedData,
    totalRoomCrtCharge,
    totalGstCrtCharge,
    totalPayableCrtAmount,
    request,
    selectedChilren,
    handleChangeRequest,
    handleChangeRooms,
    deleteCartRoom,
    changedate,
    navigateToBook,
    makePayment,
    changeCurrentPage,
    // deleteBooking,
    goBack,
    viewdeails,
    closeModal,
    editRooms,
    addMoreRooms,
    closeOpenNew,
    calculateDifference,
    formatDateRangessss,
    saveCartUpdate,
    handleChangeChildren,
  } = useCartPage(t, displayRazorpay);
  //display the data that is given from api by mapping ,
  /**
   * if there is no records found then display booknow image and button
   */
  var disabledStatus;
  if (editing === false) {
    disabledStatus = true;
  } else {
    disabledStatus = false;
  }

  const renderTopBar = () => {
    return <TopBar />;
  };

  const Tooltip = ({ text, children }) => (
    <div className="tooltip-container">
      {children}
      <span className="tooltip-text tooltip-text111">
        <ol>
          <li className="tooltip-item tooltip-item111">
            Primary guest should be atleast 18 years of age.
          </li>
          <li className="tooltip-item tooltip-item111">
            Passport, Aadhar, Driving License and Govt. ID are accepted as ID
            proof(s).
          </li>
          <li className="tooltip-item tooltip-item111">
            Pets are not allowed.
          </li>
          <li className="tooltip-item tooltip-item111">Couple Friendly.</li>
        </ol>
      </span>
    </div>
  );

  const Tooltip1 = ({ text, children }) => (
    <div className="tooltip-container">
      {children}
      <span className="tooltip-text">
        <ol>
          <li className="tooltip-item">
            Cancellations made 24 hours prior to check-in time (2:00 PM) will be
            refundable, with a deduction of 5% as a payment processing charge on
            the gross room rate (before tax amount). This policy is not
            applicable post check-in.
          </li>
          <li className="tooltip-item">
            In case of no-shows, the amount will be non-refundable and incur
            100% charges.
          </li>
          <li className="tooltip-item">
            Last-minute cancellations, i.e., 0 to 24 hours from the check-in
            time, will be partially refundable with a deduction of 20% on the
            gross room rate (before tax amount).
          </li>
          <li className="tooltip-item">
            In case of a reduction of room nights post check-in, a partial
            refund will be applicable with a deduction of 50% on the gross room
            rate (before tax amount).
          </li>
        </ol>
      </span>
    </div>
  );

  // const groupedRooms = (cartData?.data?.docs[0]?.rooms || []).reduce(
  //   (acc, room) => {
  //     const { room_type, gst, roomCharge, no_of_room, adults } = room;
  //     if (!acc[room_type]) {
  //       acc[room_type] = {
  //         room_type,
  //         gst: 0,
  //         roomCharge: 0,
  //         totalAmount: 0,
  //         no_of_room: room.no_of_room,
  //         room: room,
  //         room_image: room.room_image,
  //       };
  //     }
  //     acc[room_type].gst += gst;
  //     acc[room_type].roomCharge += roomCharge;
  //     acc[room_type].totalAmount += gst + roomCharge;
  //     return acc;
  //   },
  //   {}
  // );

  // Convert the grouped object to an array
  const groupedRooms = (cartData?.data || [])
    .flatMap((doc) => doc.rooms || [])
    .reduce((acc, room) => {
      const { room_type, gst, roomCharge, no_of_room, adults } = room;

      if (!acc[room_type]) {
        acc[room_type] = {
          room_type,
          gst: 0,
          roomCharge: 0,
          totalAmount: 0,
          no_of_room: room.no_of_room,
          room: room,
          room_image: room.room_image, // Use the first image
        };
      }

      acc[room_type].gst += gst;
      acc[room_type].roomCharge += roomCharge;
      acc[room_type].totalAmount += gst + roomCharge;

      return acc;
    }, {});
  const groupedList = Object.values(groupedRooms);

  // const profile = () => {
  //   return (
  //     <div className="my_profile flt">
  //       <div className="myprofile_main flt">
  //         <div className="row">
  //           <>
  //             {loader === "loading" && (
  //               <div className="main_load ">
  //                 <img src={Loader} alt="loader" />
  //               </div>
  //             )}
  //           </>
  //           <div className="col-sm-8">
  //             <>
  //               {loading === "loading" && (
  //                 <div className="main_load ">
  //                   <img src={Loader} alt="loader" />
  //                 </div>
  //               )}
  //               {loading !== "loading" && (
  //                 <>
  //                   {cartData && cartData?.data?.docs?.length == 0 ? (
  //                     <div className="right_profile flt">
  //                       {/* <div className="pre_booking flt">
  //                         {t("PREVIOUS_BOOKINGS")}
  //                       </div> */}
  //                       <div className="booking_backgrnd flt">
  //                         <div className="booking_ing flt">
  //                           <img src={bookingimg} alt="bookimage" />
  //                         </div>
  //                         <div className="booking_histry flt">
  //                           {t("cartHistory")}
  //                         </div>
  //                         <div className="booking_button flt">
  //                           <button type="button" onClick={navigateToBook}>
  //                             {t("Book_Now")}
  //                           </button>
  //                         </div>
  //                       </div>
  //                     </div>
  //                   ) : (
  //                     <div className="stand_room aaa flt">
  //                       {cartData?.data?.docs?.map((list) => (
  //                         <div
  //                           className={
  //                             list?.booking_status === 0
  //                               ? "seperate_room ssssas flt"
  //                               : "seperate_roomdark seperate_roomdarkssss flt"
  //                           }
  //                         >
  //                           <div
  //                             className={
  //                               list?.booking_status === 0
  //                                 ? "roomtitle flt"
  //                                 : "roomtitledark flt"
  //                             }
  //                           >
  //                             {list?.room_type}
  //                           </div>
  //                           <div className="row">
  //                             <div className="col-sm-2">
  //                               <div className="mybook_img flt">
  //                                 <img
  //                                   src={
  //                                     list?.room_image?.[0]
  //                                       ? `${process.env.REACT_APP_MEDIA_DOMAIN}${list?.room_image?.[0]}`
  //                                       : sample
  //                                   }
  //                                   alt="no_image"
  //                                 />
  //                               </div>
  //                             </div>
  //                             <div className="col-sm-5">
  //                               <ul
  //                                 className={
  //                                   list?.booking_status === 0
  //                                     ? "mybook_list flt"
  //                                     : "mybook_listdarkss flt"
  //                                 }
  //                               >
  //                                 <li>{t("Total_Guest")}</li>
  //                                 <li>
  //                                   {list?.adults ? list?.adults : "0"}{" "}
  //                                   {list?.adults === 0 || list?.adults === 1
  //                                     ? t("Adult")
  //                                     : t("Adults")}{" "}
  //                                 </li>
  //                                 <li>{t("Total_Rooms")}</li>
  //                                 <li>
  //                                   {list?.no_of_room}{" "}
  //                                   {list?.no_of_room === 1
  //                                     ? t("Room")
  //                                     : t("Rooms")}
  //                                 </li>
  //                                 <li class="total_amt">
  //                                   Total: {list?.roomCharge + list?.gst}
  //                                 </li>
  //                               </ul>
  //                             </div>
  //                             <div className="col-sm-4">
  //                               <ul
  //                                 className={
  //                                   list?.booking_status === 0
  //                                     ? "booking_confirmed flt"
  //                                     : "booking_confirmeddark flt"
  //                                 }
  //                               >
  //                                 <li>
  //                                   Check-in: {list?.arrival_date}{" "}
  //                                   {list?.arrival_time}
  //                                 </li>
  //                                 <li>
  //                                   {" "}
  //                                   Check-out: {list?.departure_date}{" "}
  //                                   {list?.departure_time}
  //                                 </li>
  //                                 <li>
  //                                   {t("Total_Length_of_stay")}{" "}
  //                                   {changedate(
  //                                     list?.arrival_date,
  //                                     list?.departure_date
  //                                   ) > 0
  //                                     ? changedate(
  //                                         list?.arrival_date,
  //                                         list?.departure_date
  //                                       )
  //                                     : "1"}
  //                                 </li>
  //                               </ul>
  //                             </div>
  //                             <div class="col-sm-1">
  //                               <div
  //                                 class="cart_delete_btn"
  //                                 onClick={() => deleteBooking(list)}
  //                               >
  //                                 <i
  //                                   className="fa fa-trash"
  //                                   aria-hidden="true"
  //                                 ></i>
  //                               </div>
  //                             </div>
  //                           </div>
  //                         </div>
  //                       ))}
  //                     </div>
  //                   )}
  //                 </>
  //               )}
  //             </>

  //             <div className="paginationdiv flt">
  //               {cartData && cartData?.data?.docs?.length !== 0 && (
  //                 <ReactPaginate
  //                   previousLabel={"previous"}
  //                   nextLabel={"next"}
  //                   breakLabel={"..."}
  //                   breakClassName={"break-me"}
  //                   pageCount={pageCount}
  //                   // currentPage={current}
  //                   showFirstLastPages={true}
  //                   marginPagesDisplayed={2}
  //                   pageRangeDisplayed={5}
  //                   onPageChange={changeCurrentPage}
  //                   containerClassName={"pagination"}
  //                   activeClassName={"active"}
  //                   forcePage={current - 1}
  //                 />
  //               )}
  //             </div>
  //           </div>
  //           <div className="col-sm-4">
  //             <div className="booking_info flt">
  //               <div className="note flt">
  //                 <img alt="no_img" src={note} />
  //                 <span className="enter_text">{t("Your_Details")}</span>
  //               </div>
  //               <div className="input_names cartt flt">
  //                 <ul className="room_charge ">
  //                   <li>
  //                     <div className="charges2">{t("Full_Name")}</div>
  //                     <div className="charges2 charges_bold">{user_name}</div>
  //                   </li>
  //                   <li>
  //                     <div className="charges2">{t("Email_Addres")} </div>
  //                     <div className="charges2 charges_bold">{user_email}</div>
  //                   </li>
  //                   <li>
  //                     <div className="charges2"> {t("Mobile_Number")}</div>
  //                     <div className="charges2 charges_bold">{user_phone}</div>
  //                   </li>
  //                 </ul>
  //               </div>
  //             </div>
  //             {cartData && cartData?.data?.docs?.length !== 0 && (
  //               <div className="main_services flt">
  //                 <div class="price_details_head flt">Payment Details</div>
  //                 <div className="main_room_charge flt">
  //                   <ul className="room_charge ">
  //                     <li>
  //                       <div className="charges2">{t("Room_Charges")}</div>
  //                       <div className="charges2 charges_bold">
  //                         ₹{" "}
  //                         {commaValidation(
  //                           Number(calculatedRoomCharge).toFixed(2)
  //                         )}
  //                       </div>
  //                     </li>
  //                     <li>
  //                       <div className="charges2">{t("tax")} </div>
  //                       <div className="charges2 charges_bold">
  //                         ₹{" "}
  //                         {commaValidation(Number(calculatedTaxgst).toFixed(2))}
  //                       </div>
  //                     </li>
  //                   </ul>
  //                   <hr className="line" />
  //                 </div>

  //                 <div className="main_total_amt flt">
  //                   <ul className="total_amt flt">
  //                     <li>
  //                       <div className="ammount_clr">
  //                         {t("Total_Payable_Amount")}
  //                       </div>
  //                       <div className="ammount_clr_no">
  //                         {" "}
  //                         ₹{" "}
  //                         {commaValidation(
  //                           Number(calculatedTotalAmt).toFixed(2)
  //                         )}
  //                       </div>
  //                     </li>
  //                     <hr className="line1" />
  //                   </ul>
  //                 </div>
  //                 <div className="Verfie flt">
  //                   <button onClick={makePayment}>{t("Pay_Now")}</button>
  //                 </div>
  //               </div>
  //             )}
  //           </div>
  //         </div>
  //       </div>
  //     </div>
  //   );
  // };

  const profile = () => {
    return (
      <>
        {loader === "loading" && (
          <div className="main_load ">
            <img src={Loader} alt="loader" />
          </div>
        )}
        {/* <div className="main_load ">
          <img src={Loader} alt="loader" />
        </div> */}
        <div className="cart_page">
          <div className="info">
            <div className="heading_txt">
              Cart Sorted by Matching Check-In, Checkout Dates, and Room
            </div>
            <div>
              <img src={back_btn} onClick={goBack} />
            </div>
          </div>
          {/* {cartData?.data?.docs?.map((list) => (
            <div className="card_container flt">
              <div className="card_details">
                Check-in: {list.arrival_date} 2:00 PM{" "}
                <span className="gold_span">|</span> Check-out:{" "}
                {list.departure_date} 12:00 PM
              </div>
              {list?.rooms?.map((listss) => (
                <div className="card">
                  <div className="card_top">
                    <p className="heading">{listss.room_type}</p>
                    <div className="options">
                      <div
                        className="option"
                        onClick={() => viewdeails(listss, list)}
                      >
                        <img src={view_headline} alt="" />
                        <p>View Details</p>
                      </div>
                      <div
                        className="option"
                        onClick={() => editRooms(listss, list)}
                      >
                        <img src="" alt="" />
                        <p>Edit/Remove</p>
                      </div>
                    </div>
                  </div>
                  <div className="card_bottom">
                    <div className="card_bottom_left">
                      <img
                        src={
                          listss?.room_image[0]
                            ? `${process.env.REACT_APP_MEDIA_DOMAIN}${listss?.room_image?.[0]}`
                            : sample
                        }
                        alt="no_image"
                      />

                      <div className="room_details">
                        <span>Total Guest</span>
                        <p>{listss.adults} Adults</p>
                      </div>
                      <div className="room_details">
                        <span>Total Rooms</span>
                        <p>{listss.no_of_room}</p>
                      </div>
                      <div className="room_details">
                        <span>Total Length of stay</span>
                        <p>
                          {calculateDifference(
                            list.arrival_date,
                            list.departure_date
                          )}{" "}
                          Days
                        </p>
                      </div>
                    </div>
                    <div className="card_bottom_right">
                      <div className="price_details">
                        <span>Total Tax</span>
                        <p>
                          ₹ {commaValidation(Number(listss.gst).toFixed(2))}{" "}
                        </p>
                      </div>
                      <div className="price_details">
                        <span>Total Room Charges</span>
                        <p>
                          ₹{" "}
                          {commaValidation(
                            Number(listss.roomCharge).toFixed(2)
                          )}{" "}
                        </p>
                      </div>
                      <div className="price_details">
                        <span>Total Amount</span>
                        <p className="total">
                          ₹{" "}
                          {commaValidation(
                            Number(listss.gst + listss.roomCharge).toFixed(2)
                          )}{" "}
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          ))} */}

          {/* Working Code Expect ROOMS
          {cartData?.data?.docs?.map((list) => {
            // Group rooms by room_typeId
            const groupedRooms = list.rooms.reduce((acc, room) => {
              const key = room.roomTypeId;
              if (!acc[key]) {
                acc[key] = { ...room, count: 1 };
              } else {
                acc[key].count += 1;
                acc[key].adults += room.adults;
                acc[key].no_of_room += room.no_of_room;
                acc[key].gst += room.gst;
                acc[key].roomCharge += room.roomCharge;
              }
              return acc;
            }, {});

            return (
              <div className="card_container flt" key={list.id}>
                <div className="card_details">
                  Check-in: {list.arrival_date} 2:00 PM{" "}
                  <span className="gold_span">|</span> Check-out:{" "}
                  {list.departure_date} 12:00 PM
                </div>
                {Object.values(groupedRooms).map((groupedRoom) => (
                  <div className="card" key={groupedRoom.roomTypeId}>
                    <div className="card_top">
                      <p className="heading">{groupedRoom.room_type}</p>
                      <div className="options">
                        <div
                          className="option"
                          onClick={() => viewdeails(groupedRoom, list)}
                        >
                          <img src={view_headline} alt="" />
                          <p>View Details</p>
                        </div>
                        <div
                          className="option"
                          onClick={() => editRooms(groupedRoom, list)}
                        >
                          <img src="" alt="" />
                          <p>Edit/Remove</p>
                        </div>
                      </div>
                    </div>
                    <div className="card_bottom">
                      <div className="card_bottom_left">
                        <img
                          src={
                            groupedRoom?.room_image[0]
                              ? `${process.env.REACT_APP_MEDIA_DOMAIN}${groupedRoom?.room_image[0]}`
                              : sample
                          }
                          alt="no_image"
                        />
                        <div className="room_details">
                          <span>Total Guest</span>
                          <p>
                            {groupedRoom.adults /
                              calculateDifference(
                                list.arrival_date,
                                list.departure_date
                              )}
                          </p>
                   
                        </div>
                        <div className="room_details">
                          <span>Total Rooms</span>

                          <p>
                            {list.rooms.length /
                              calculateDifference(
                                list.arrival_date,
                                list.departure_date
                              )}
                          </p>
                       
                        </div>
                        <div className="room_details">
                          <span>Total Length of stay</span>
                          <p>
                            {calculateDifference(
                              list.arrival_date,
                              list.departure_date
                            )}{" "}
                            Days
                          </p>
                        </div>
                      </div>
                      <div className="card_bottom_right">
                        <div className="price_details">
                          <span>Total Tax</span>
                          <p>
                            ₹{" "}
                            {commaValidation(
                              Number(groupedRoom.gst).toFixed(2)
                            )}{" "}
                          </p>
                        </div>
                        <div className="price_details">
                          <span>Total Room Charges</span>
                          <p>
                            ₹{" "}
                            {commaValidation(
                              Number(groupedRoom.roomCharge).toFixed(2)
                            )}{" "}
                          </p>
                        </div>
                        <div className="price_details">
                          <span>Total Amount</span>
                          <p className="total">
                            ₹{" "}
                            {commaValidation(
                              Number(
                                groupedRoom.gst + groupedRoom.roomCharge
                              ).toFixed(2)
                            )}{" "}
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>
                ))}
              </div>
            );
          })} */}

          {cartData?.data?.map((list) => {
            // Group rooms by roomTypeId
            const groupedRooms = list.rooms.reduce((acc, room) => {
              const key = room.roomTypeId;
              if (!acc[key]) {
                acc[key] = { ...room, count: 1 };
              } else {
                acc[key].count += 1;
                acc[key].adults += room.adults;
                acc[key].infants = [...acc[key].infants, ...room.infants];
                acc[key].infantsUnder8 = [
                  ...acc[key].infantsUnder8,
                  ...room.infantsUnder8,
                ];
                acc[key].infantsAbove8 = [
                  ...acc[key].infantsAbove8,
                  ...room.infantsAbove8,
                ];
                acc[key].no_of_room += room.no_of_room;
                acc[key].gst += room.gst;
                acc[key].roomCharge += room.roomCharge;
              }
              return acc;
            }, {});

            return (
              <div className="card_container flt" key={list.id}>
                <div className="card_details">
                  Check-in:
                  {new Date(list?.arrival_date)
                    .toLocaleDateString("en-GB")
                    .replace(/\//g, "-")}
                  , 2:00 PM <span className="gold_span">|</span> Check-out:{" "}
                  {new Date(list?.departure_date)
                    .toLocaleDateString("en-GB")
                    .replace(/\//g, "-")}
                  , 12:00 PM
                </div>
                {Object.values(groupedRooms).map((groupedRoom) => {
                  // Filter rooms for the current roomTypeId
                  const filteredRooms = list.rooms.filter(
                    (room) => room.roomTypeId === groupedRoom.roomTypeId
                  );

                  return (
                    <div className="cardss" key={groupedRoom.roomTypeId}>
                      <div className="card_top">
                        <p className="heading">{groupedRoom.room_type}</p>

                        <div className="options">
                          <div className="cancelationDetail">
                            <Tooltip1>
                              <p>Cancellation Policy Details</p>
                            </Tooltip1>
                          </div>
                          {/* <div style={{ padding: "50px" }}>
                            <Tooltip text="This is a tooltip">
                              <button>Hover me</button>
                            </Tooltip>
                          </div> */}
                          <div className="option">
                            {/* <img src={view_headline} alt="" /> */}
                            <div className="tooltip-arrow"></div>
                            <Tooltip>
                              <p>Important information</p>
                            </Tooltip>
                          </div>
                          <div
                            className="option"
                            onClick={() => viewdeails(groupedRoom, list)}
                          >
                            <img src={view_headline} alt="" />
                            <p>View Details</p>
                          </div>
                          {/* <div
                            className="option"
                            onClick={() => editRooms(groupedRoom, list)}
                          >
                            <img src="" alt="" />
                            <p>Remove Rooms</p>
                          </div> */}
                        </div>
                      </div>
                      <div className="card_bottom">
                        <div className="card_bottom_left">
                          <img
                            src={
                              groupedRoom?.room_image[0]
                                ? `${process.env.REACT_APP_MEDIA_DOMAIN}${groupedRoom?.room_image[0]}`
                                : sample
                            }
                            alt="no_image"
                          />
                          <div className="room_details">
                            <span>Total Adults</span>
                            <p>
                              {groupedRoom.adults /
                                calculateDifference(
                                  list.arrival_date,
                                  list.departure_date
                                ) -
                                Number(groupedRoom.infantsAbove8.length) /
                                  calculateDifference(
                                    list.arrival_date,
                                    list.departure_date
                                  )}{" "}
                            </p>
                            {/* <p>{groupedRoom.adults} Adults</p> */}
                          </div>
                          <div className="room_details">
                            <span>Total Children</span>
                            {/* <p>{groupedRoom?.infantsUnder8?.replace(/,/g, '')}</p> */}
                            {/* <p>
                              {
                                groupedRoom?.infantsUnder8?.replaceAll(",", "")
                                  .length
                              }
                            </p> */}
                            <br></br>
                            <b>
                              {groupedRoom.infants.length /
                                calculateDifference(
                                  list.arrival_date,
                                  list.departure_date
                                )}{" "}
                              {/* {groupedRoom.infantsAbove8}{" "}
                              {groupedRoom.infantsUnder8} */}
                              {/* {Array.isArray(groupedRoom?.infantsUnder8)
                                ? groupedRoom?.infantsUnder8.join("").length // Joins array elements without commas
                                : groupedRoom?.infantsUnder8?.replaceAll(
                                    ",",
                                    ""
                                  ).length} */}
                            </b>
                            {/* {groupedRoom.infants && (
                              <span className="displayAgee">
                                ({groupedRoom.infants.join("y, ")}y){" "}
                              </span>
                            )} */}

                            {groupedRoom.infants && (
                              <span className="displayAgee">
                                (
                                {[...groupedRoom.infants]
                                  .sort((a, b) => a - b) // Sort in ascending order
                                  .filter(
                                    (_, index) =>
                                      index %
                                        calculateDifference(
                                          list.arrival_date,
                                          list.departure_date
                                        ) ===
                                      0
                                  )
                                  .join("y, ")}
                                y){" "}
                              </span>
                            )}

                            {/* {groupedRoom.infants && (
                              <span className="displayAgee">
                                (
                                {groupedRoom.infants
                                  .filter((_, index) => {
                                    const step = list.rooms[0].infants.length;
                                    const skip =
                                      calculateDifference(
                                        list.arrival_date,
                                        list.departure_date
                                      ) * step;
                                    const maxLength = Math.floor(
                                      groupedRoom.infants.length /
                                        calculateDifference(
                                          list.arrival_date,
                                          list.departure_date
                                        )
                                    );
                                    const selectedCount =
                                      Math.floor(index / (step + skip)) * step;
                                    return (
                                      index % (step + skip) < step &&
                                      selectedCount < maxLength
                                    );
                                  })
                                  .slice(
                                    0,
                                    groupedRoom.infants.length /
                                      calculateDifference(
                                        list.arrival_date,
                                        list.departure_date
                                      )
                                  )
                                  .join("y, ")}
                                y)
                              </span>
                            )} */}

                            {/* {groupedRoom.infants && (
                              <span className="displayAgee">
                                (
                                {groupedRoom.infants
                                  .slice(
                                    0,
                                    Math.ceil(
                                      groupedRoom.infants.length /
                                        calculateDifference(
                                          list.arrival_date,
                                          list.departure_date
                                        )
                                    )
                                  )
                                  .join("y, ")}
                                y)
                              </span>
                            )} */}

                            {/* <p>{groupedRoom?.infantsUnder8}</p> */}
                            {/* <p>{groupedRoom.adults} Adults</p> */}
                          </div>
                          <div className="room_details">
                            <span>Total Rooms</span>
                            <p>
                              {filteredRooms.length /
                                calculateDifference(
                                  list.arrival_date,
                                  list.departure_date
                                )}
                            </p>
                            {/* <p>{groupedRoom.no_of_room}</p> */}
                          </div>
                          <div className="room_details">
                            <span>Total Length of stay</span>
                            <p>
                              {calculateDifference(
                                list.arrival_date,
                                list.departure_date
                              )}{" "}
                              Days
                            </p>
                          </div>
                        </div>
                        <div className="card_bottom_right">
                          <div className="price_details">
                            <span>Total Tax</span>
                            <p>
                              ₹{" "}
                              {commaValidation(
                                Number(groupedRoom.gst).toFixed(2)
                              )}{" "}
                            </p>
                          </div>
                          <div className="price_details">
                            <span>Total Room Charges</span>
                            <p>
                              ₹{" "}
                              {commaValidation(
                                Number(groupedRoom.roomCharge).toFixed(2)
                              )}{" "}
                            </p>
                          </div>
                          <div className="price_details">
                            <span>Total Amount</span>
                            <p className="total">
                              ₹{" "}
                              {commaValidation(
                                Number(
                                  groupedRoom.gst + groupedRoom.roomCharge
                                ).toFixed(2)
                              )}{" "}
                            </p>
                          </div>
                        </div>
                      </div>
                    </div>
                  );
                })}
              </div>
            );
          })}

          {cartData && cartData?.data?.length !== 0 && (
            <div className="customer_info">
              <div className="customer_info_left">
                <span className="name">{user_name}</span>
                <span>{user_phone}</span>
                <span>{user_email}</span>
              </div>
              <div className="customer_info_right">
                <p className="customer_info_heading">Total Payment Details</p>
                <div className="final_price_details">
                  <span>Total Tax</span>

                  <p>₹ {commaValidation(Number(totalingGst).toFixed(2))}</p>
                </div>
                <div className="final_price_details">
                  <span>Total Room Charges</span>
                  <p>
                    ₹ {commaValidation(Number(totalingRoomCharge).toFixed(2))}
                  </p>
                </div>
                <div className="final_price_details">
                  <span>Total Amount</span>
                  <p className="total">
                    ₹{" "}
                    {commaValidation(
                      Number(totalingGst + totalingRoomCharge).toFixed(2)
                    )}
                  </p>
                </div>
              </div>
            </div>
          )}

          {cartData && cartData?.data?.length !== 0 && (
            <div className="special_request_container">
              <p className="special_request">Special Request</p>
              <div>
                <textarea
                  placeholder="Enter any special Request"
                  value={request}
                  onChange={handleChangeRequest}
                ></textarea>
              </div>
            </div>
          )}

          {/* {cartData && cartData?.data?.length !== 0 && (
            <div className="paginationdiv flt">
              <ReactPaginate
                previousLabel={"previous"}
                nextLabel={"next"}
                breakLabel={"..."}
                breakClassName={"break-me"}
                pageCount={pageCount}
                // currentPage={current}
                showFirstLastPages={true}
                marginPagesDisplayed={2}
                pageRangeDisplayed={5}
                onPageChange={changeCurrentPage}
                containerClassName={"pagination"}
                activeClassName={"active"}
                forcePage={current - 1}
              />
            </div>
          )} */}

          <Modal
            open={removeRooms}
            aria-labelledby="modal-modal-title"
            aria-describedby="modal-modal-description"
            className="modal_container"
          >
            <div className="view_details_popup ">
              <div className="view_details_header">
                <p className="heading">Remove Rooms</p>
                <div className="options">
                  <img src={close} onClick={closeModal} />
                </div>
              </div>
              <p className="date_details">
                Check-in:{" "}
                {new Date(singleRoom?.arrival_date)
                  .toLocaleDateString("en-GB")
                  .replace(/\//g, "-")}{" "}
                2:00 PM <span className="gold_span">| </span>
                Check-out:{" "}
                {new Date(singleRoom?.departure_date)
                  .toLocaleDateString("en-GB")
                  .replace(/\//g, "-")}{" "}
                12:00 PM
              </p>
              <div className="">
                <div className="row">
                  <div className="col-sm-6">
                    <div className="main_content_left">
                      <div className="main_content_heading">
                        <p className="heading">{singleViewDetails.room_type}</p>
                        <p className="price">
                          Price: 
                          <span>
                            ₹{" "}
                            {commaValidation(
                              Number(singleViewDetails.roomCharge).toFixed(2)
                            )}
                          </span>
                        </p>
                      </div>
                      <div className="main_content_details">
                        <div className="details_left">
                          <img src={traced} />
                          <p>Total Rooms</p>
                        </div>
                        <div>
                          <p>
                            {singleRoom?.rooms?.filter(
                              (room) =>
                                room.roomTypeId === singleViewDetails.roomTypeId
                            ).length /
                              calculateDifference(
                                singleRoom.arrival_date,
                                singleRoom.departure_date
                              ) || 0}
                          </p>
                        </div>
                      </div>
                      {Array.from(
                        {
                          length:
                            singleRoom?.rooms?.filter(
                              (room) =>
                                room.roomTypeId === singleViewDetails.roomTypeId
                            ).length /
                              calculateDifference(
                                singleRoom.arrival_date,
                                singleRoom.departure_date
                              ) || 0,
                        },

                        (_, roomIndex) => (
                          <div className="edit_cart_rooms" key={roomIndex}>
                            <div className="main_content_room_details">
                              <div className="color_wrapper">
                                {roomIndex + 1}
                              </div>
                              <p className="asas">Room {roomIndex + 1}</p>
                              <p className="asaseee">Total Adults</p>
                              <p className="asaseeeff">
                                {selectedAdults[roomIndex] -
                                  selectedChilrenAbove8[roomIndex]}
                              </p>

                              <p className="asaseee">Total Children</p>
                              <p className="asaseeeff">
                                {selectedChilren[roomIndex]}
                              </p>
                            </div>
                            <div>
                              <button
                                className="room_remove"
                                onClick={() =>
                                  deleteCartRoom(
                                    roomIndex,
                                    selectedAdults[roomIndex],
                                    singleViewDetails
                                  )
                                }
                              >
                                <img src={delete_img} />
                              </button>
                            </div>
                          </div>
                        )
                      )}
                    </div>
                    <div className="note_txxxt">
                      <span>Note: </span>
                      <ul>
                        <li>
                          Complimentary breakfast served with veg options.
                        </li>
                        <li>
                          Extra Adult Charge: ₹
                          {singleViewDetails.extraOccupancy} + applicable taxes.
                        </li>
                        <li>
                          Extra Child Charge (8 years and above): ₹
                          {singleViewDetails.extraOccupancy}+ applicable taxes.
                        </li>
                      </ul>
                    </div>
                  </div>
                  <div className="col-sm-6">
                    <div className="main_services fff flt">
                      <div className="main_room_charge flt">
                        <div className="booking_pay_txt flt">
                          Booking and Payment Details
                        </div>
                        <ul className="room_charge flt ">
                          <li>
                            <div className="charges2">Date</div>
                            <div className="charges2 charges_bold">
                              {formatDateRangessss(
                                singleRoom.arrival_date,
                                singleRoom.departure_date
                              )}
                              {/* 13 to 14 April 2022 */}
                            </div>
                          </li>
                          <li>
                            <div className="charges2">
                              Total Length of stay 
                            </div>
                            <div className="charges2 charges_bold">
                              {calculateDifference(
                                singleRoom.arrival_date,
                                singleRoom.departure_date
                              )}{" "}
                              Days
                            </div>
                          </li>
                          <li>
                            <div className="charges2">Total Room Charges </div>
                            <div className="charges2 charges_bold">
                              ₹{" "}
                              {commaValidation(
                                Number(
                                  totalRoomCrtCharge
                                    ? totalRoomCrtCharge
                                    : singleViewDetails.roomCharge
                                ).toFixed(2)
                              )}
                            </div>
                          </li>
                          <li>
                            <div className="charges2">Total Tax</div>
                            <div className="charges2 charges_bold">
                              ₹{" "}
                              {commaValidation(
                                Number(
                                  totalGstCrtCharge
                                    ? totalGstCrtCharge
                                    : singleViewDetails.gst
                                ).toFixed(2)
                              )}
                            </div>
                          </li>
                          <li className="last_total">
                            <div className="charges2">
                              {t("Total_Payable_Amount")}
                            </div>
                            <div className="ammount_clr_no">
                              ₹{" "}
                              {commaValidation(
                                Number(
                                  totalPayableCrtAmount
                                    ? totalPayableCrtAmount
                                    : singleViewDetails.gst +
                                        singleViewDetails.roomCharge
                                ).toFixed(2)
                              )}
                            </div>
                          </li>
                        </ul>
                      </div>

                      {user_id && (
                        <div className="account_details flt">
                          <div className="namee">
                            <img src={account_circle} />
                            {user_name}
                          </div>
                          <div className="details">
                            <span>
                              <img src={phone_in_talk} /> {user_phone}
                            </span>
                            <span>
                              <img src={mail} />
                              {user_email}
                            </span>
                          </div>
                        </div>
                      )}

                      {/* <div className=" editRooms flt">
                        <button className="close_btn flt" onClick={closeModal}>
                          X Close
                        </button>
                        <button
                          className="save_changes_btn flt"
                          onClick={saveCartUpdate}
                        >
                          Save Changes
                        </button>
                      </div> */}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </Modal>

          <Modal
            open={viewDetails}
            aria-labelledby="modal-modal-title"
            aria-describedby="modal-modal-description"
            className="modal_container"
          >
            <div className="view_details_popup mobileViewModal">
              <div className="view_details_header">
                <p className="heading">Cart Details</p>
                <div className="options">
                  {/* <div className="option" onClick={addMoreRooms}>
                    <img src={add_shopping_cart2} />
                    <p className="addMoreRoom">Add More Rooms</p>
                  </div> */}
                  {/* <div className="option" onClick={closeOpenNew}>
                    <img src={production_quantity_limits2} />
                    <p className="editRemove">Remove Rooms</p>
                  </div> */}
                  <img src={close} onClick={closeModal} />
                </div>
              </div>
              <p className="date_details">
                Check-in:{" "}
                {new Date(singleRoom?.arrival_date)
                  .toLocaleDateString("en-GB")
                  .replace(/\//g, "-")}{" "}
                2:00 PM <span className="gold_span">| </span>
                Check-out:{" "}
                {new Date(singleRoom?.departure_date)
                  .toLocaleDateString("en-GB")
                  .replace(/\//g, "-")}{" "}
                12:00 PM
              </p>
              <div className="">
                <div className="row">
                  <div className="col-sm-6">
                    <div className="main_content_left">
                      <div className="main_content_heading">
                        <p className="heading">{singleViewDetails.room_type}</p>
                        <p className="price">
                          Price: 
                          <span>
                            ₹{" "}
                            {commaValidation(
                              Number(singleViewDetails.roomCharge).toFixed(2)
                            )}
                          </span>
                        </p>
                      </div>
                      <div className="main_content_details">
                        <div className="details_left">
                          <img src={traced} />
                          <p>Total Rooms</p>
                        </div>
                        <div>
                          <p>
                            {singleRoom?.rooms?.filter(
                              (room) =>
                                room.roomTypeId === singleViewDetails.roomTypeId
                            ).length /
                              calculateDifference(
                                singleRoom.arrival_date,
                                singleRoom.departure_date
                              ) || 0}
                            {/* {singleRoom?.rooms?.length /
                              calculateDifference(
                                singleRoom.arrival_date,
                                singleRoom.departure_date
                              )} */}
                          </p>
                        </div>
                      </div>
                      {Array.from(
                        {
                          length:
                            singleRoom?.rooms?.filter(
                              (room) =>
                                room.roomTypeId === singleViewDetails.roomTypeId
                            ).length /
                              calculateDifference(
                                singleRoom.arrival_date,
                                singleRoom.departure_date
                              ) || 0,
                        },
                        // {
                        //   length:
                        //     singleRoom?.rooms?.length /
                        //       calculateDifference(
                        //         singleRoom.arrival_date,
                        //         singleRoom.departure_date
                        //       ) || 0,
                        // },
                        (_, roomIndex) => (
                          <div
                            className="main_content_room_details"
                            key={roomIndex}
                          >
                            <div className="color_wrapper">{roomIndex + 1}</div>
                            <p className="asas">Room {roomIndex + 1}</p>
                            <p className="asaseee">Total Adults</p>
                            <p className="asaseeeff">
                              {selectedAdults[roomIndex] -
                                selectedChilrenAbove8[roomIndex]}
                            </p>
                            <p className="asaseee">Total Children</p>
                            <p className="asaseeeff">
                              {selectedChilren[roomIndex]}
                            </p>
                          </div>
                        )
                      )}

                      {/* {singleRoom?.rooms?.map((list) => (
                        <div className="main_content_room_details">
                          <div className="color_wrapper">1</div>
                          <p className="asas">Room 1</p>

                          <p className="asaseee">Total Adults</p>
                          <p>2</p>
                        </div>
                      ))} */}
                      {/* <div className="main_content_room_details">
                        <div className="color_wrapper">2</div>
                        <p className="asas">Room 2</p>

                        <p className="asaseee">Total Adults</p>
                        <p>2</p>
                      </div>
                      <div className="main_content_room_details">
                        <div className="color_wrapper">3</div>
                        <p className="asas">Room 3</p>

                        <p className="asaseee">Total Adults</p>
                        <p>2</p>
                      </div> */}
                    </div>
                    <div className="note_txxxt">
                      <span>Note: </span>
                      <ul>
                        <li>
                          Complimentary breakfast served with veg options.
                        </li>
                        <li>
                          Extra Adult Charge: ₹
                          {singleViewDetails.extraOccupancy} + applicable taxes.
                        </li>
                        <li>
                          Extra Child Charge (8 years and above): ₹
                          {singleViewDetails.extraOccupancy}+ applicable taxes.
                        </li>
                      </ul>
                    </div>
                  </div>
                  <div className="col-sm-6">
                    <div className="main_services fff flt">
                      <div className="main_room_charge flt">
                        <div className="booking_pay_txt flt">
                          Booking and Payment Details
                        </div>
                        <ul className="room_charge flt ">
                          <li>
                            <div className="charges2">Date</div>
                            <div className="charges2 charges_bold">
                              {formatDateRangessss(
                                singleRoom.arrival_date,
                                singleRoom.departure_date
                              )}
                              {/* 13 to 14 April 2022 */}
                            </div>
                          </li>
                          <li>
                            <div className="charges2">
                              Total Length of stay 
                            </div>
                            <div className="charges2 charges_bold">
                              {calculateDifference(
                                singleRoom.arrival_date,
                                singleRoom.departure_date
                              )}{" "}
                              Days
                            </div>
                          </li>
                          <li>
                            <div className="charges2">Total Room Charges </div>
                            <div className="charges2 charges_bold">
                              ₹{" "}
                              {commaValidation(
                                Number(singleViewDetails.roomCharge).toFixed(2)
                              )}
                            </div>
                          </li>
                          <li>
                            <div className="charges2">Total Tax</div>
                            <div className="charges2 charges_bold">
                              ₹{" "}
                              {commaValidation(
                                Number(singleViewDetails.gst).toFixed(2)
                              )}
                            </div>
                          </li>
                          <li className="last_total">
                            <div className="charges2">
                              {t("Total_Payable_Amount")}
                            </div>
                            <div className="ammount_clr_no">
                              ₹{" "}
                              {commaValidation(
                                Number(
                                  singleViewDetails.gst +
                                    singleViewDetails.roomCharge
                                ).toFixed(2)
                              )}
                            </div>
                          </li>
                        </ul>
                      </div>

                      {user_id && (
                        <div className="account_details flt">
                          <div className="namee">
                            <img src={account_circle} />
                            {user_name}
                          </div>
                          <div className="details">
                            <span>
                              <img src={phone_in_talk} /> {user_phone}
                            </span>
                            <span>
                              <img src={mail} />
                              {user_email}
                            </span>
                          </div>
                        </div>
                      )}
                    </div>
                  </div>
                </div>

                {/* <div className="main_content_right">
                <div className="main_content_heading">
                  <p>Standard Room</p>
                  <p>
                    Price: <span>₹ 1,000</span>
                  </p>
                </div>
                <div className="main_content_details">
                  <div className="details_left">
                    <img src="" />
                    <p>Total Rooms </p>
                  </div>
                  <p>6</p>
                </div>
                <div className="main_content_room_details">
                  <div className="color_wrapper">1</div>
                  <p>Room 2</p>
                  
                  <p>Total Adults</p>
                  <p>2</p>
                </div>
                <div className="main_content_room_details">
                  <div className="color_wrapper">1</div>
                  <p>Room 2</p>
                  
                  <p>Total Adults</p>
                  <p>2</p>
                </div>
                <div className="main_content_room_details">
                  <div className="color_wrapper">1</div>
                  <p>Room 2</p>
                  
                  <p>Total Adults</p>
                  <p>2</p>
                </div>
              </div> */}
              </div>
            </div>
          </Modal>
        </div>
        {cartData && cartData?.data?.length !== 0 && (
          <div className="payment_info">
            <div></div>
            {/* <p className="mobile_hide">Total Payable</p> */}
            <div className="payment_info_right">
              {/* <button onClick={addMoreRooms}>
                <img src={add_shopping_cart2} alt="" />
                <span>Add More Rooms</span>
              </button> */}
              <button onClick={makePayment}> Make Payment</button>
            </div>
          </div>
        )}
        {cartData && cartData?.data?.length == 0 && (
          <div className="right_profile flt">
            <div className="booking_backgrnd flt">
              <div className="booking_ing flt">
                <img src={bookingimg} alt="bookimage" />
              </div>
              <div className="booking_histry flt">{t("cartHistory")}</div>
              <div className="booking_button flt">
                <button type="button" onClick={navigateToBook}>
                  {t("Book_Now")}
                </button>
              </div>
            </div>
          </div>
        )}
      </>
    );
  };

  return (
    <div className="main_container">
      {renderTopBar()}
      {profile()}
    </div>
  );
};

export default withTranslation()(CartPage);
